import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Margin of Error',
		description:
			'Increase the margin of error to 99%. Now every poll can mean anything!'
	},
	{
		name: 'Sample Size: 1',
		description:
			'Ask your cousin what they think and extrapolate to the entire population.'
	},
	{
		name: 'Reverse Psychology',
		description:
			'Ask the opposite of what you want to know. Psychology never lies.'
	},
	{
		name: 'Poll the Plants',
		description:
			"Office plants have opinions too. They're very grounded in their views."
	},
	{
		name: 'Time Travel Polls',
		description:
			'Poll people from the future. They seem oddly concerned about something.'
	},
	{
		name: 'Quantum Polling',
		description:
			'All poll responses exist in a superposition until observed. Schrödinger approves.'
	},
	{
		name: 'Poll the Void',
		description:
			'The void stares back with some interesting demographic insights.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Poll Analysis Lab'],
	departments[DepartmentIds['Poll Analysis Lab']].basePrice * 3,
	UpgradeIds.PalExponent1
)

export default array
